
import Vue from 'vue' 
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VTooltip from 'v-tooltip'  
import store from '@/state/store'
import App from './App.vue'  
import i18n from './helpers/i18n'
import tinymce from 'vue-tinymce-editor'
import axios from 'axios'
import { BootstrapVue, IconsPlugin,ToastPlugin,BToast } from 'bootstrap-vue'  
import VSwitch from 'v-switch-case' 
import VueExcelEditor from 'vue-excel-editor'
import Toast from "vue-toastification";
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs' 
import "vue-toastification/dist/index.css";  
import "../src/design/app.scss";
import "../src/design/css/main.css";
import "../src/design/css/bootstrap.min.css";
import "../src/design/css/bootstrap-touch-slider.css";
import "../src/design/css/fontawesome.min.css"; 
import VueDragAndDropList from 'vue-drag-and-drop-list';

import VueNestable from 'vue-nestable'
import CountryFlag from 'vue-country-flag'


fetch(window.location.protocol+"//"+window.location.host+"/assets/config.json")
.then(response => response.json())
.then(config => { 

Vue.prototype.$config = config    
axios.defaults.baseURL = config.API_URL

axios.defaults.headers.common = { 'Authorization': 'Bearer '+store.getters.["auth/JWToken"] }

Vue.use(VueNestable)
Vue.use(VueDragAndDropList);
var VueCookie = require('vue-cookie'); 
Vue.use(VueCookie);
Vue.use(VueCookies)
Vue.use(VueCryptojs)
Vue.use(VTooltip)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)
Vue.component('b-toast', BToast) 
Vue.component('country-flag', CountryFlag)
 

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});
 

Vue.use(VueExcelEditor)


Vue.use(VSwitch)
 
 

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

//Vue.use(BootstrapVue)

Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
}) 